// src/Components/Animations/WelcomeBanner.jsx
import { motion } from "framer-motion";

export default function WelcomeBanner({ name }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-6 rounded-xl text-white shadow-md"
    >
      <h1 className="text-2xl font-semibold">👋 Welcome, {name}!</h1>
      <p className="text-sm text-white/80">Let’s boost your ad performance today.</p>
    </motion.div>
  );
}
